const env = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  s3BaseUrl: process.env.REACT_APP_AWS_S3_BASE_URL,
  ggMapAPIKey: process.env.REACT_APP_GG_MAP_API_KEY
};

export default env;
